import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html'
import useCsrfToken from '../hooks/useCsrfToken';

Serviciosmini.propTypes = {
    listingid: PropTypes.string,
    bgmode: PropTypes.string
};

export default function Serviciosmini({ listingid, bgmode = '' }) {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    const stripTagsFromHtml = (html) => {
        const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
        return sanitizeHtml(html, {
            allowedTags: allowedTags
        });
    };

    useEffect(() => {
        const transformData = (data) => {
            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Instalaciones y servicios',
                name: data.title,
                slug: data.slug,
                intro: data.intro !== '' ? stripTagsFromHtml(data.intro) : '',
                desc: data.description.length > 100 ? stripTagsFromHtml(data.description).substring(0, 100) + '...' : stripTagsFromHtml(data.description),
                tags: data.tags,
                gallery: data.gallery?.gallerythumbs,
                gallerylarge: data.gallery?.galleryimages,
                brochure_url: data.brochure_url,
                cta_url: data.cta_url,
                phone_1: data.phone_1,
                title: data.title,
                listing_type: data.listing_type,
                embed: data.embed,
                cta_icon: data.cta_icon
            };
        };
        if (!listingid) return;
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings-by-tag/${listingid}/instalation`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    if (data.length && !data.error) {
                        const transformedListings = data.map(item => transformData(item));
                        setListings(transformedListings);
                    }

                })
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [listingid, API_URL, csrfToken]);
    return (
        <>
            {listings && listings.length > 0 && (
                <section className={`section ${bgmode}`}>
                    <div className="container mt-20">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="section-title text-center mb-2 pb-1">
                                    <h4 className="title mb-3">Instalaciones y Servicios relacionados</h4>
                                </div>
                            </div>
                        </div>
                        {listings && listings.length > 0 && (
                            <div className="row">
                                {listings.map((item, index) => {
                                    const stripTags = (html) => {
                                        let doc = new DOMParser().parseFromString(html, 'text/html');
                                        return doc.body.textContent || "";
                                    };
                                    return (
                                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                                            <div className="listing position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                                <div className="position-relative">
                                                    <div className="listing-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                                        <Link to={`/servicio/${item.slug}`}>
                                                            <img src={item.image} className="img-fluid" alt={item.name} />
                                                        </Link>
                                                    </div>

                                                    <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                                        <Link to="#" className="badge bg-success">{item.tag}</Link>
                                                    </div>
                                                </div>

                                                <div className="pt-4 flex-grow-1 d-flex flex-column">
                                                    <Link to={`/servicio/${item.slug}`} className="text-dark title h5">{item.name}</Link>

                                                    <p className="text-muted my-2 flex-grow-1">{stripTags(item.desc)}</p>

                                                    <Link to={`/servicio/${item.slug}`} className="btn btn-success w-100 btn-sm text-light mt-auto hv:bg-secondary">Conocer más <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </section>
            )}
        </>
    )
}
